import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UserAuthService } from '../services/user-auth.service';

@Injectable({ providedIn: 'root' })
export class ActiveSessionGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly userAuthService: UserAuthService,
    private readonly cookieService: CookieService
  ) { }

  canActivate(): boolean | UrlTree {
    if (this.userAuthService.getAccessToken()) {
      return true;
    }

    this.clearSession();
    return this.router.parseUrl('/login');
  }

  private clearSession() {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {
      // storage is unavailable (e.g. blocked by the browser) - nothing to clear
    }
    this.cookieService.delete('submissionId', '/');
    this.cookieService.delete('userId', '/');
  }
}
